import { render, staticRenderFns } from "./BaseArticle.vue?vue&type=template&id=e0821aa2&"
import script from "./BaseArticle.vue?vue&type=script&lang=js&"
export * from "./BaseArticle.vue?vue&type=script&lang=js&"
import style0 from "./BaseArticle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports